var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "common" },
    [
      _c(
        "div",
        { staticStyle: { "text-align": "center" } },
        [
          _c("div", { staticClass: "item-box" }, [_vm._v("即将支付")]),
          _vm._v(" "),
          _c("div", { staticClass: "item-box" }, [
            _c("label", { staticClass: "text-color-orange" }, [
              _vm._v(_vm._s(_vm._f("splitK")(_vm.totalAmt)) + " 元")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item-box" }, [
            _c("label", [_vm._v("接收方：")]),
            _vm._v(_vm._s(_vm.modalData.recPersonInfo.cstNm) + "\n    ")
          ]),
          _vm._v(" "),
          _c("a-input", {
            staticClass: "item-input",
            attrs: { type: "password", placeholder: "交易密码" },
            model: {
              value: _vm.txnPwd,
              callback: function($$v) {
                _vm.txnPwd = $$v
              },
              expression: "txnPwd"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("a-divider"),
      _vm._v(" "),
      _c(
        "a-form-model",
        {
          ref: "ruleForm",
          staticClass: "common-form-inline",
          attrs: {
            model: _vm.goldpageData,
            "label-col": { span: 3 },
            "wrapper-col": { span: 13 }
          }
        },
        [
          _c(
            "a-form-model-item",
            { attrs: { label: "附件上传", prop: "fileId" } },
            [
              _c(
                "div",
                { staticStyle: { position: "relative" } },
                [
                  _c("fileUpload", {
                    ref: "fileUpload",
                    attrs: {
                      accept:
                        ".png,.PNG,.jpg,.JPG,.jpeg,.JPEG,.bmp,.pdf,.PDF,.zip",
                      paramObj: _vm.uploadParam,
                      removeaction: true,
                      limit: 50,
                      fileListShow: false,
                      name: "file"
                    },
                    on: {
                      uploadOkCopy: _vm.uploadOkCopy,
                      handleFileRemove: _vm.removeOk
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-color-orange img-tip" }, [
                    _vm._v(
                      "温馨提示：1、每次上传最多不超过50个文件\n          2、支持PNG、JPG、JPEG、PDF、单个文件不能超过100M"
                    )
                  ])
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("a-table", {
        attrs: {
          pagination: false,
          columns: _vm.columns,
          "data-source": _vm.tableData,
          bordered: "",
          locale: { emptyText: "暂无数据" }
        },
        scopedSlots: _vm._u([
          {
            key: "fileName",
            fn: function(text, record) {
              return [_c("a", [_vm._v(_vm._s(text))])]
            }
          },
          {
            key: "status",
            fn: function(text, record) {
              return [_c("div", [_vm._v(_vm._s(text))])]
            }
          },
          {
            key: "action",
            fn: function(text, record) {
              return [
                _c(
                  "div",
                  [
                    _c(
                      "a-button",
                      {
                        attrs: { type: "link" },
                        on: {
                          click: function($event) {
                            return _vm.handleSort(record, "up")
                          }
                        }
                      },
                      [_vm._v("上移")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a-button",
                      {
                        attrs: { type: "link" },
                        on: {
                          click: function($event) {
                            return _vm.handleSort(record, "down")
                          }
                        }
                      },
                      [_vm._v("下移")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a-button",
                      {
                        attrs: { type: "link" },
                        on: {
                          click: function($event) {
                            return _vm.handleDel(record)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "spaceCenter model-footer-btns" },
        [
          _c(
            "a-button",
            {
              staticClass: "btn-blue-line btn-big",
              on: { click: _vm.modalCancel }
            },
            [_vm._v("取消")]
          ),
          _vm._v(" "),
          _c(
            "a-button",
            {
              staticClass: "btn-big",
              attrs: {
                type: "primary",
                loading: _vm.modalLoad,
                disabled: !_vm.txnPwd
              },
              on: { click: _vm.modalOk }
            },
            [_vm._v("确定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60022084", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60022084","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gold-page/gold-pay-modal.vue
// module id = 3LyG
// module chunks = 1